module.exports = __webpack_public_path__ + "img/badge-apple-fr.8943920e.svg";